import React, { useEffect } from 'react';
import { Layout, Table, Tag, Button, Spin, Space, Modal, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAttendance, verifyAttendance } from '../redux/slices/attendanceSlice';
import AttendanceMarker from '../components/AttendanceMarker';

function Attendance() {
  const dispatch = useDispatch();
  const { records, pagination, isLoading } = useSelector(state => state.attendance);

  useEffect(() => {
    dispatch(fetchAttendance({ page: 1, limit: 10 }));
  }, [dispatch]);

  const handleVerify = (id) => {
    Modal.confirm({
      title: 'Verify Attendance',
      content: 'Verify this attendance record?',
      onOk() {
        dispatch(verifyAttendance({ id, isVerified: true, verificationNotes: 'Verified by HR' }))
          .then(() => message.success('Verified'))
          .catch(err => message.error(err || 'Failed'));
      }
    });
  };

  const columns = [
    { title: 'Date', dataIndex: 'date', key: 'date', render: (d) => new Date(d).toLocaleDateString() },
    { title: 'Check-in', dataIndex: 'checkInTime', key: 'checkInTime', render: (t) => t ? new Date(t).toLocaleTimeString() : '-' },
    { title: 'Check-out', dataIndex: 'checkOutTime', key: 'checkOutTime', render: (t) => t ? new Date(t).toLocaleTimeString() : '-' },
    { title: 'Hours', dataIndex: 'workingHours', key: 'workingHours', render: (h) => h ? `${h}h` : '-' },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (s) => <Tag color={s === 'Present' ? 'green' : 'red'}>{s}</Tag> },
    { title: 'Actions', key: 'actions', render: (_, r) => <Button size="small" onClick={() => handleVerify(r.id)}>Verify</Button> }
  ];

  return (
    <Layout style={{ padding: '20px' }}>
      <h1>Attendance Tracking</h1>
      <AttendanceMarker />
      <br />
      <Spin spinning={isLoading}>
        <Table columns={columns} dataSource={records} pagination={pagination} rowKey="id" />
      </Spin>
    </Layout>
  );
}

export default Attendance;
